import {
  Heading,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Text,
  VStack,
} from '@chakra-ui/react';
import {IModalProps, InfinityScrollButton, Modal} from 'components/shared';
import {useTranslation} from 'hooks';
import {FC} from 'react';
import {modalCloseButtonStyles} from 'theme';
import {IOrder} from 'types';

import {Order} from './components';

export interface Props extends IModalProps {
  orders: IOrder[];
  onHandlerSetLimit: () => void;
  isLoadingOrders: boolean;
}

export const UserOrdersModal: FC<Props> = ({orders, onHandlerSetLimit, isLoadingOrders, isOpen, onClose}) => {
  const {t} = useTranslation();
  const showData = !!orders?.length;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalContent maxW="700px" maxH="90vh" overflow="hidden" mx={['10px', 0]}>
        <ModalHeader p="30px 30px 0" display="flex" alignItems="center" justifyContent="space-between">
          <Heading fontSize="24px" fontWeight="bold">
            {t('MY_ORDERS')}
          </Heading>
          <ModalCloseButton position="static" sx={modalCloseButtonStyles} />
        </ModalHeader>
        <ModalBody p="30px" overflowY="scroll">
          {showData ? (
            <>
              <VStack pb="30px" spacing="20px" h="full">
                {orders.map((item) => (
                  <Order t={t} key={item.uuid} order={item} />
                ))}
              </VStack>
              <InfinityScrollButton
                fetchNextPage={onHandlerSetLimit}
                isFetchingNextPage={isLoadingOrders}
                providerPageCount={orders.length}
              />
            </>
          ) : (
            <Text>{t('YOU_HAVE_NO_ORDERS')}</Text>
          )}
        </ModalBody>
        <ModalFooter />
      </ModalContent>
    </Modal>
  );
};
